import React, { useEffect } from 'react';
import {
	Pulse,
	DEVICES,
	getCurrentEnv,
	NavigationHelpers,
	Button,
	useDeviceType,
	FooterLines
} from 'common-utilities';
import { EVENT_CATEGORY, SCREEN_NAME } from '../../constants';
import PaytmLogo from '../../assets/paytmSheild.svg';
import { If, When, Choose, Otherwise } from 'babel-plugin-jsx-control-statements';
import './style.scss';

const ENV = getCurrentEnv();
const screenName = SCREEN_NAME + '_success';
function Success(props) {
	const Device = useDeviceType();
	const user_mobile = sessionStorage && sessionStorage.getItem('USER_MOBILE');
	const user_email = sessionStorage && sessionStorage.getItem('USER_EMAIL');
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');

	useEffect(() => {
		Pulse.push({
			event_action: 'password_success_screen_loaded',
			event_category: EVENT_CATEGORY,
			screenName
		});
	}, []);

	const onLoginClick = () => {
		Pulse.push({
			event_action: 'goto_paytm_clicked',
			event_category: EVENT_CATEGORY,
			screenName
		});
	};

	return (
		<React.Fragment>
			<div className="successPageContainer">
				<div className="header-logo-cont">
					<img className="sheild-img" src={PaytmLogo} alt="paytm-icon" />
				</div>
				<div className="infoContainer">
					<div className="heading">Reset Password Successful</div>
					<div className="info" style={{ fontSize: '14px', marginTop: '40px' }}>
						Your new password has been successfully set for paytm account linked to{' '}
						{user_mobile ? `number ${user_mobile}` : `email ${user_email}`}.
					</div>
				</div>
				<Choose>
					<When condition={Device === DEVICES.DESKTOP}>
						<div className="buttonContainer" style={{ marginTop: '30px' }}>
							<Button
								onClick={() => {
									onLoginClick();
									NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
								}}
								oauth-id="goto_paytm_btn"
							>
								Go to Paytm
							</Button>
						</div>
					</When>
					<Otherwise>
						<div className="mobileButtonContainer" style={{ marginTop: '30px' }}>
							<button
								className="button primary"
								onClick={() => {
									onLoginClick();
									NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
								}}
								oauth-id="goto_paytm_btn"
							>
								Go to Paytm App
							</button>
						</div>
					</Otherwise>
				</Choose>
				<FooterLines />
			</div>
		</React.Fragment>
	);
}
export default Success;
